module.exports = __webpack_public_path__ + "c_static/img/3-1京东-加入购物车.cb94344.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/电脑端轨迹加权/3-1京东-加入购物车.jpg
// module id = ZmdS
// module chunks = 33